export default {"src":"/_next/static/media/calling.c0897505.gif","height":50,"width":50,"blurWidth":0,"blurHeight":0};